import React from 'react';
import Layout from '../../components/Layout';
import Page from '../../components/Page';
import cite from './cite.md';

function action() {
  return {
    chunks: ['cite'],
    title: cite.title,
    component: (
      <Layout>
        <Page {...cite} />
      </Layout>
    ),
  };
}

export default action;
